import { HurricaneProvider } from '../providers/hurricaneProvider.js';
import { mapParamsToObject } from '../../utilities/mapParamsToObject';

//Actions are payloads of information that send data from your application to your store. They are the only source of information for the store. To change data, we need to dispatch an action

export const GET_HURRICANE_BY_LATLON = 'GET_HURRICANE_BY_LATLON';
export const GET_HURRICANE_BY_LATLON_PENDING = 'GET_HURRICANE_BY_LATLON_PENDING';
export const GET_HURRICANE_BY_LATLON_FULFILLED = 'GET_HURRICANE_BY_LATLON_FULFILLED';
export const GET_HURRICANE_BY_LATLON_REJECTED = 'GET_HURRICANE_BY_LATLON_REJECTED';
export const GET_HURRICANE_LEGEND = 'GET_HURRICANE_LEGEND';
export const GET_HURRICANE_LEGEND_PENDING = 'GET_HURRICANE_LEGEND_PENDING';
export const GET_HURRICANE_LEGEND_FULFILLED = 'GET_HURRICANE_LEGEND_FULFILLED';
export const GET_HURRICANE_LEGEND_REJECTED = 'GET_HURRICANE_LEGEND_REJECTED';
export const SELECT_HURRICANE = 'SELECT_HURRICANE';
export const SELECT_HURRICANE_TRACK_POINT = 'SELECT_HURRICANE_TRACK_POINT';

export function getHurricaneByLatLon(...params) {
    let paramsObject = {
        latitude: undefined,
        longitude: undefined,
        isCached: undefined,
        baseUrl: undefined,
        path: undefined,
        authId: undefined,
        secret: undefined,
        stdParameters: undefined,
        unitParameters: undefined,
        verbose: undefined,
        refresh: undefined
    };

    paramsObject = mapParamsToObject(params, paramsObject);

    return {
        type: GET_HURRICANE_BY_LATLON,
        payload: getHurricane(paramsObject)
    };
}

export function getHurricaneLegend(isCached, baseUrl, path, authId, secret, stdParameters) {
    return {
        type: GET_HURRICANE_LEGEND,
        payload: getHurricaneLegendAsync(isCached, baseUrl, path, authId, secret, stdParameters)
    };
}

export function selectHurricane(hurricaneId) {
    return {
        type: SELECT_HURRICANE,
        payload: hurricaneId
    };
}

export function selectHurricaneTrackPoint(trackPoint) {
    return {
        type: SELECT_HURRICANE_TRACK_POINT,
        payload: trackPoint
    };
}

async function getHurricane({ latitude, longitude, isCached, baseUrl,
    path, authId, secret, stdParameters, unitParameters, verbose }) {
    const op = new HurricaneProvider(baseUrl, authId, secret);
    return await op.getHurricane(latitude, longitude, isCached, stdParameters, unitParameters, path, verbose);
}

async function getHurricaneLegendAsync(isCached, baseUrl, path, authId, secret, stdParameters) {
    const op = new HurricaneProvider(baseUrl, authId, secret);
    return await op.getHurricaneLegend(isCached, stdParameters, path);
}
